// components/SlideInOnScroll.jsx
"use client";

import { motion, useAnimation, useInView } from "framer-motion";
import { useEffect, useRef, useState } from "react";

export default function SlideInOnScroll({ children, from = "left", delay = 0 }) {
  const controls = useAnimation();
  const ref = useRef(null);
  const inView = useInView(ref, {
    margin: "-100px",
  });
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    if (inView && !hasAnimated) {
      controls.start("visible");
      setHasAnimated(true); // 只执行一次
    }
  }, [inView, hasAnimated, controls]);

  // 根据方向决定初始 X 偏移
  const offsetX = from === "right" ? 80 : -80;

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={controls}
      transition={{ duration: 1.0, ease: "easeOut", delay }}
      variants={{
        hidden: { opacity: 0, x: offsetX },
        visible: { opacity: 1, x: 0 },
      }}
    >
      {children}
    </motion.div>
  );
}
